/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../../assets/Icons";
import PrimaryButton from "../../../../../components/_utils/CommonButtons/PrimaryButton";
import TopNavComponent from "../../../../../components/_utils/CommonTopNav/TopNavComponent";
import FormatAmount from "../../../../../components/_utils/FormatAmount/FormatAmount";
import PaginationComponent from "../../../../../components/_utils/PaginationComponent";
import BeneficiaryAccountDetailsPopup from "../../../../../components/Accounts/BeneficiaryAccount/BeneficiaryAccountDetailsPopup/index.jsx";
import Loader from "../../../../../components/Loader/Index";
import ScheduleBeneficiaryTransactionDetailsPopup from "../../../../../components/Transactions/ScheduleBeneficiaryTransaction/ScheduleBeneficiaryTransactionDetailsPopup/index.jsx";
import ScheduleBeneficiaryTransactionMultiApprovalCard from "../../../../../components/Transactions/ScheduleBeneficiaryTransaction/ScheduleBeneficiaryTransactionMultiApprovalCard/index.jsx";
import { getAllBeneficiaryAccounts } from "../../../../../redux/features/accounts/beneficiaryAccount/index.js";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { ownerAccountsViewAll } from "../../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import { getAllCategories } from "../../../../../redux/features/sharedResources/sharedResources";
import {
  resetBeneScheduleTransactionsApproval,
  resetBeneScheduleTransactionsReject,
  scheduledBeneficiaryViewAll,
} from "../../../../../redux/features/transactions/scheduleBeneficiaryTransactions/index.js";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../../../utils/configurationProvider";
import { standardAccountNumberFormat } from "../../../../../utils/standardAccountNumberFormat";

const ScheduleBeneficiaryMultiSelect = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [datas, setDatas] = useState([]);
  const [txnId, setTxnId] = useState(null);
  const [active, setActive] = useState("");
  const [, setIsOpen] = useState(false);
  const [mainData, setMainData] = useState([]);
  const [inputData, setInputData] = useState([]);
  const [, setTotalPages] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [searchdata, SetsearchData] = useState("");
  const [totalAmount, setTotalAmount] = useState(0);
  const [allAccounts, setAllAccounts] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const [endDateFilter, setEndDateFilter] = useState("");
  const [selectedValue, setSelectedValue] = useState(50);
  const [dropdownOptions] = useState(PaginationConfiguration.paginationOptions);
  const [isDrawerOpen, setisDrawerOpen] = useState(false);
  const [detailSelected, setDetailSelected] = useState("");
  const [selectAllCard, setselectAllCard] = useState(false);
  const [isPaymentMethod, setIsPaymentMethod] = useState("");
  const [startDateFilter, setStartDateFilter] = useState("");
  const [txnAmountFilter, setTxnAmountFilter] = useState("");
  const [BeneTxnDetailsId, SetBeneTxnDetailsId] = useState("");
  const [approvedAccounts, setApprovedAccounts] = useState([]);
  const [accountNameValue, setAccountNameValue] = useState("");
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [showTxnDetailPop, setShowTxnDetailPop] = useState(false);
  const [initCategoryFilter, setInitCategoryFilter] = useState("");
  const [displayCategory, setDisplayCategory] = useState("");
  const [LabelSearchText, setLabelSearchText] = useState([]);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [FrequencyMethodfilter, setFrequencyMethodfilter] = useState("");
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [DestinationAccountName, setDestinationAccountName] = useState("");
  const [selectedSendTransactions, setSelectedSendTransactions] = useState([]);
  const [confidentialMethodFilter, setConfidentialMethodFilter] = useState("");
  const [allBeneScheduleTxnLoading, setAllBeneScheduleTxnLoading] =
    useState(false);
  const [pageSize, setPageSize] = useState(
    window.innerWidth >= 3840 ? 250 : window.innerWidth >= 2560 ? 102 : 50,
  );
  const [txnPayLoadAccountNameFilter, setTxnPayLoadAccountNameFilter] =
    useState("");
  const [txnPayLoadDesitinationNameFilter, setTxnPayLoadDestinationNameFilter] =
    useState("");
  const [txnPayLoad, setTxnPayLoad] = useState({
    bankAccountName: "",
    beneAccountId: "",
    bankAccountNo: "",
    bankAccountIFSC: "",
    ownerAccountId: "",
    amount: "",
    ownerbankAccountNo: "",
  });
  const [beneAccountId] = useState(
    txnPayLoad?.beneAccountId ? txnPayLoad?.beneAccountId : null,
  );

  const [accountNumber, setAccountNumber] = useState(
    txnPayLoad?.bankAccountNo ? txnPayLoad?.bankAccountNo : "",
  );
  const [accountName, setAccountName] = useState(
    txnPayLoad?.bankAccountName ? txnPayLoad?.bankAccountName : "",
  );

  const {
    beneficiaryTransactionsDetailsData,
    beneficiaryTransactionsApproveError,
    beneficiaryTransactionsRejectError,
  } = useSelector((state) => state.beneficiaryTransactions);

  const allCategories = useSelector(
    (state) => state.sharedResources?.categoriesData?.categories,
  );

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const fetchData = async () => {
    setLoadingData(true);

    let response;
    let data = [];

    try {
      switch (active) {
        case "Category":
          response = await dispatch(
            getAllCategories({ search_string: searchUserTextDebounce }),
          );
          data =
            response?.payload?.categories?.map((itm) => ({
              id: itm.id,
              Category: itm.name,
              Description: itm?.description || "Not given",
            })) || [];
          break;

        case "Labels":
          const available = mainData?.summary?.available_labels || [];

          const filtered = available.filter((l) =>
            l.toLowerCase().includes(searchUserTextDebounce.toLowerCase()),
          );

          data =
            filtered
              ?.filter((itm) => itm.includes(searchUserTextDebounce))
              ?.map((val) => ({ id: val, Label: val })) || [];
          break;

        case "Beneficiary account":
          response = await dispatch(
            getAllBeneficiaryAccounts({
              search_string: searchUserTextDebounce,
              page_no: GlobalConfiguration?.lengthCheckOne,
              page_size: GlobalConfiguration?.lengthCheckFive,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.beneficiary_accounts?.map((itm) => ({
                id: itm.id,
                Name: itm.name,
                Account_number: itm.bank_acc_no,
                display: itm.name,
                IFSC_code: itm.ifsc_code,
                Contact_number: itm.contact_no,
                Email_ID: itm.email_id,
              })) || [];
          }
          break;
        case "Search":
          SetsearchData(searchUserTextDebounce);
          setLoadingData(false);
          setAllBeneScheduleTxnLoading(false);
          break;

        case "Owner account":
          response = await dispatch(
            ownerAccountsViewAll({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.owner_accounts?.map((itm) => ({
                id: itm.id,
                Account_number: itm.bank_acc_no,
                display: itm.bank_acc_no,
                Name: itm.name,
                IFSC_code: itm.ifsc_code,
                Email_ID: itm.email_id,
              })) || [];
          }
          break;

        default:
          data = [];
          break;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      data = [];
    } finally {
      setInputData([...data]);
      setLoadingData(false);
    }
  };

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const handleStartDateChange = (date) => {
    setStartDateFilter(date);
  };

  const handleEndDateChange = (date) => {
    setEndDateFilter(date);
  };

  const fetchTransactions = async () => {
    setAllBeneScheduleTxnLoading(true);

    try {
      let queryParams = {
        page_no: page,
        page_item_count: pageSize,
        lifecycle_status: "pending",
      };

      if (FrequencyMethodfilter !== "") {
        queryParams.frequency = FrequencyMethodfilter.toLowerCase().replace(
          /\s+/g,
          "_",
        );
      }
      if (searchdata !== "") {
        queryParams.scheduled_name = searchdata;
      }

      if (initCategoryFilter !== "") {
        queryParams.category_id = initCategoryFilter;
      }
      if (startDateFilter) {
        queryParams.transaction_start_date = formatDate(startDateFilter);
      }

      if (endDateFilter) {
        queryParams.transaction_end_date = formatDate(endDateFilter);
      }
      if (isPaymentMethod && isPaymentMethod !== "All") {
        queryParams.payment_method = isPaymentMethod;
      }
      if (confidentialMethodFilter !== "") {
        queryParams.confidential_transaction = confidentialMethodFilter;
      }

      if (txnAmountFilter !== "") {
        queryParams.amount = txnAmountFilter;
      }

      if (DestinationAccountName !== "") {
        queryParams.beneficiary_account_id = DestinationAccountName;
      }

      if (txnPayLoadAccountNameFilter !== "") {
        queryParams.owner_account_id = txnPayLoadAccountNameFilter;
      }

      if (LabelSearchText?.length) {
        queryParams.labels = LabelSearchText;
      }

      const response = await dispatch(scheduledBeneficiaryViewAll(queryParams));

      const newData = response?.payload?.transactions || [];
      const formattedData =
        newData?.map((account) => ({
          ...account,
          loading: false,
          error: "false",
          message: "",
          last_updated_user_id_check: "false",
          distribution_lifecycle_status: "",
        })) || [];
      setTotalCount(
        response?.payload?.total_count || GlobalConfiguration.lengthCheckZero,
      );
      setMainData(response?.payload);
      setAllAccounts(formattedData);
      const approved = newData.filter(
        (account) => account.beneficiary_account_approval_status === "approved",
      );
      setApprovedAccounts((prevApproved) => [...prevApproved, ...approved]);
    } catch (error) {
      console.error("Failed to fetch transactions:", error);
      setMainData([]);
      setAllAccounts([]);
    } finally {
      setAllBeneScheduleTxnLoading(false);
    }
  };

  const handleSelectAll = (tt) => {
    const alreadySelectedCount = selectedTransactions?.length;
    const remainingSelections =
      GlobalConfiguration?.categorymaxLength - alreadySelectedCount;
    if (tt) {
      let x = [];
      approvedAccounts.map((itm) => {
        if (selectedTransactions.includes(itm.txn_id)) {
          x.push(itm.txn_id);
        }
      });
      let y = selectedTransactions.filter((it) => !x.includes(it));
      let z = selectedSendTransactions.filter((itm) => !x.includes(itm.txn_id));
      setSelectedTransactions(y);
      setSelectedSendTransactions(z);
      let amt = z.reduce((sum, account) => sum + Number(account.amount), 0);
      setTotalAmount(amt);
    } else if (remainingSelections === GlobalConfiguration.lengthCheckZero) {
      setSelectedTransactions([]);
      setSelectedSendTransactions([]);
      setTotalAmount(0);
    } else {
      if (remainingSelections > GlobalConfiguration.lengthCheckZero) {
        const newSelections = allAccounts
          .filter(
            (account) =>
              account.beneficiary_account_approval_status === "approved" &&
              !selectedTransactions.includes(account.txn_id),
          )
          .slice(0, remainingSelections)
          .map((account) => account.txn_id);

        const newSelectionsSend = allAccounts
          .filter(
            (account) =>
              account.beneficiary_account_approval_status === "approved" &&
              !selectedTransactions.includes(account.txn_id),
          )
          .slice(0, remainingSelections)
          .map((account) => account);

        setSelectedTransactions((prevSelected) => [
          ...prevSelected,
          ...newSelections,
        ]);

        setSelectedSendTransactions((prevSelected) => [
          ...prevSelected,
          ...newSelectionsSend,
        ]);

        const newAmounts = allAccounts
          .filter((account) => newSelections.includes(account.txn_id))
          .reduce((sum, account) => sum + Number(account.amount), 0);

        setTotalAmount((prevAmount) => prevAmount + newAmounts);
      } else {
        let x = [];
        approvedAccounts.map((itm) => {
          if (selectedTransactions.includes(itm.txn_id)) {
            x.push(itm.txn_id);
          }
        });
        let y = selectedTransactions.filter((it) => !x.includes(it));
        let z = selectedSendTransactions.filter(
          (itm) => !x.includes(itm.txn_id),
        );
        setSelectedTransactions(y);
        setSelectedSendTransactions(z);
        let amt = z.reduce((sum, account) => sum + Number(account.amount), 0);
        setTotalAmount(amt);
      }
    }
  };
  const formatDate = (date) => {
    const day = String(date.getDate())?.padStart(2, "0");
    const month = String(date.getMonth() + 1)?.padStart(2, "0");
    const year = date?.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const handleSelect = (value) => {
    setSelectedValue(value);
    setPageSize(value);
    setPage(GlobalConfiguration.lengthCheckOne);
  };

  const handlePagination = (page) => {
    setPage(page);
  };

  const handleClearParams = () => {
    setFrequencyMethodfilter("");
    SetsearchData("");
    setTxnPayLoadAccountNameFilter("");
    setInitCategoryFilter("");
    setLabelSearchText([]);
    setStartDateFilter("");
    setEndDateFilter("");
    setIsPaymentMethod("");
    setTxnAmountFilter("");
    setTxnPayLoad({
      ...txnPayLoad,
      amount: "",
    });
    setConfidentialMethodFilter("");
    setTxnPayLoadDestinationNameFilter("");
    setTxnPayLoad((prev) => ({
      ...prev,
      bankAccountNo: "",
    }));
    setDestinationAccountName("");
    setPage(1);
    // Reload logic if needed, but useEffect depends on these states so it should trigger
  };

  const handleFrequencyMethod = (selectedSettlement) => {
    setFrequencyMethodfilter(selectedSettlement);
  };
  const handlePaymentMethod = (selectedSettlement) => {
    setIsPaymentMethod(selectedSettlement);
  };

  const handleConfidentialMethod = (selectedSettlement) => {
    setConfidentialMethodFilter(selectedSettlement);
  };

  const openBeneTxnDetailModal = () => {
    setShowTxnDetailPop(true);
    setDetailSelected("Additional details");
  };
  const closeBeneTxnDetailModal = () => {
    setShowTxnDetailPop(false);
  };

  const closeBeneAccountDetailModal = () => {
    setisDrawerOpen(false);
  };

  const SideDrawerOpen = async (id) => {
    SetBeneTxnDetailsId(id);
    setisDrawerOpen(!isDrawerOpen);
  };

  const handleBeneDetailPopupApprove = () => {
    return;
    // left to be used later
    // eslint-disable-next-line no-unreachable
    let storedData = JSON.parse(sessionStorage.getItem("selectedscheduleData"));
    if (storedData) {
      const updatedTransactions = storedData.selectedSendTransactions.filter(
        (transaction) => transaction.txn_id !== txnId,
      );
      const updatedTransactionsId = storedData.selectedTransactions.filter(
        (transaction) => transaction !== txnId,
      );

      sessionStorage.setItem(
        "selectedscheduleData",
        JSON.stringify({
          ...storedData,
          selectedSendTransactions: updatedTransactions,
          selectedTransactions: updatedTransactionsId,
        }),
      );
      setSelectedSendTransactions(updatedTransactions);
      setSelectedTransactions(updatedTransactionsId);
      setTimeout(() => {
        setShowTxnDetailPop(false);
      }, 6000);
    }
  };

  const updateIsFilterApplied = () => {
    setIsFilterApplied(
      isPaymentMethod !== "" ||
        FrequencyMethodfilter !== "" ||
        confidentialMethodFilter !== "" ||
        txnPayLoadDesitinationNameFilter !== "" ||
        searchdata !== "" ||
        initCategoryFilter !== "" ||
        startDateFilter ||
        endDateFilter ||
        txnAmountFilter !== "" ||
        DestinationAccountName !== "" ||
        txnPayLoadAccountNameFilter !== "" ||
        LabelSearchText?.length > GlobalConfiguration?.lengthCheckZero,
    );
  };

  useEffect(() => {
    if (active?.length) {
      fetchData();
    }
  }, [active, searchUserTextDebounce]);

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    dispatch(resetBeneScheduleTransactionsReject());
    dispatch(resetBeneScheduleTransactionsApproval());
  }, [beneficiaryTransactionsApproveError, beneficiaryTransactionsRejectError]);

  useEffect(() => {
    fetchTransactions();
  }, [
    dispatch,
    markerData,
    page,
    pageSize,
    isPaymentMethod,
    txnPayLoadDesitinationNameFilter,
    txnPayLoadAccountNameFilter,
    startDateFilter,
    DestinationAccountName,
    initCategoryFilter,
    FrequencyMethodfilter,
    endDateFilter,
    confidentialMethodFilter,
    txnAmountFilter,
    searchdata,
    LabelSearchText,
  ]);

  useEffect(() => {
    const newTotalPages = Math.ceil(totalCount / pageSize);
    setTotalPages(newTotalPages);

    setPage((prevPage) => {
      if (newTotalPages === GlobalConfiguration.lengthCheckZero) {
        return 1;
      }
      if (prevPage > newTotalPages) {
        return newTotalPages;
      }
      return prevPage;
    });
  }, [totalCount, pageSize]);

  useEffect(() => {
    setDatas({
      ...datas,
      owner_account_balance_last_fetched_at_in_words:
        beneficiaryTransactionsDetailsData?.transaction[0]
          ?.owner_account_balance_last_fetched_at_in_words,
      owner_account_balance:
        beneficiaryTransactionsDetailsData?.transaction[0]
          ?.owner_account_balance,
      owner_account_balance_last_fetched_at:
        beneficiaryTransactionsDetailsData?.transaction[0]
          ?.owner_account_balance_last_fetched_at,
    });
  }, [beneficiaryTransactionsDetailsData]);

  useEffect(() => {
    updateIsFilterApplied();
  }, [
    FrequencyMethodfilter,
    isPaymentMethod,
    LabelSearchText,
    confidentialMethodFilter,
    txnPayLoadDesitinationNameFilter,
    initCategoryFilter,
    startDateFilter,
    endDateFilter,
    txnAmountFilter,
    searchdata,
    DestinationAccountName,
    txnPayLoadAccountNameFilter,
  ]);

  return (
    <>
      {showTxnDetailPop && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <ScheduleBeneficiaryTransactionDetailsPopup
            postRejectAdvice={handleBeneDetailPopupApprove}
            postApproveAdvice={handleBeneDetailPopupApprove}
            closeScheduleTxnDetailModal={closeBeneTxnDetailModal}
            txn_id={txnId}
            detailSelected={detailSelected}
          />
        </div>
      )}
      {isDrawerOpen && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <BeneficiaryAccountDetailsPopup
            closeBeneAccountDetailModal={closeBeneAccountDetailModal}
            bene_account_id={BeneTxnDetailsId}
            type={"bene_account_detail_modal"}
          />
        </div>
      )}

      <div
        className="bg-primary-bg flex flex-col h-screen relative overflow-hidden"
        style={{
          background: showInnerSearchBar ? "var(--bg-PopUp-BackDrop)" : "",
        }}
      >
        <div className="w-width-full h-height-full">
          <div className="w-width-full h-height-full relative  flex flex-col  overflow-hidden">
            {/* ----Header web Section---------- */}
            <div className="w-width-full h-navbar-breadcrumb-height Qmd:block hidden bg-primary-nav flex-shrink-0"></div>
            <div className="relative z-z-index-overlay">
              <TopNavComponent
                topNavHeader={totalAmount}
                topNavSubText="Total amount"
                ispagination={
                  allAccounts?.length <= GlobalConfiguration.lengthCheckZero
                    ? false
                    : true
                }
                handleBack={() => navigate(-1)}
                isSelectionView={true}
                selectionText={`Transactions selected : ${selectedTransactions?.length}`}
                selectionBtnProps={{
                  isDisabled: !allAccounts?.length,
                  btnText: "Select up to 20",
                  btnType: "button",
                  enabledBgColor:
                    selectedTransactions?.length <
                      GlobalConfiguration?.categorymaxLength &&
                    approvedAccounts.length !==
                      GlobalConfiguration?.lengthCheckZero &&
                    approvedAccounts.every((itm) =>
                      selectedTransactions.includes(itm.txn_id),
                    )
                      ? "var(--positive-bg)"
                      : selectedTransactions?.length ===
                          GlobalConfiguration?.categorymaxLength
                        ? "var(--positive-bg)"
                        : "var(--primary-nav-act)",
                  hoverOption:
                    selectedTransactions?.length <
                      GlobalConfiguration?.categorymaxLength &&
                    approvedAccounts.length !==
                      GlobalConfiguration?.lengthCheckZero &&
                    approvedAccounts.every((itm) =>
                      selectedTransactions.includes(itm.txn_id),
                    )
                      ? "black"
                      : selectedTransactions?.length ===
                          GlobalConfiguration?.categorymaxLength
                        ? "black"
                        : "white",
                  enabledTextColor: "var(--text-primary)",
                  icon:
                    selectedTransactions?.length <
                      GlobalConfiguration?.categorymaxLength &&
                    approvedAccounts.length !==
                      GlobalConfiguration?.lengthCheckZero &&
                    approvedAccounts.every((itm) =>
                      selectedTransactions.includes(itm.txn_id),
                    )
                      ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                      : selectedTransactions?.length ===
                          GlobalConfiguration?.categorymaxLength
                        ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                        : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
                  handleFunction: () => {
                    setselectAllCard(
                      approvedAccounts.every((itm) =>
                        selectedTransactions.includes(itm.txn_id),
                      )
                        ? true
                        : selectAllCard
                          ? false
                          : true,
                    );
                    handleSelectAll(
                      approvedAccounts.every((itm) =>
                        selectedTransactions.includes(itm.txn_id),
                      ),
                    );
                  },
                }}
                topNavCtaBtn2Props={{
                  btnText: "Next",
                  btnType: "button",
                  enabledBgColor: "var(--text-primary)",
                  inActiveVariantNeeded: true,
                  handleFunction: () => {
                    if (
                      selectedTransactions?.length >=
                      GlobalConfiguration?.lengthCheckOne
                    ) {
                      const selectedData = {
                        selectedSendTransactions,
                        selectedTransactions,
                        timestamp: Date.now(),
                      };
                      sessionStorage.setItem(
                        "selectedscheduleData",
                        JSON.stringify(selectedData),
                      );
                      navigate(
                        "/beneficiary_transaction_dashboard/schedule_multi_approval/schedules_multi_approval",
                      );
                    }
                  },
                  enabledTextColor: "var(--primary-bg)",
                  isDisabled: !selectedTransactions?.length,
                  disabledBgColor: "var(--text-disabled)",
                  disabledTextColor: "var(--text-primary)",
                }}
                isToggleNeeded={true}
                toggleProps={{
                  state: false,
                  isDisabled: false,
                  title: "Single Approval",
                  handleClick: () =>
                    navigate(
                      "/beneficiary_transaction_dashboard/schedule_single_approval",
                    ),
                }}
                filteredSearchProps={{
                  setShowInnerSearchBar: setShowInnerSearchBar,
                  showSearchBar: true,
                  isSearchDisabled: allBeneScheduleTxnLoading,
                  onSearchInput: handleSearch,
                  searchText: searchUserTextDebounce,
                  searchPlaceholder: "Search schedule beneficiary transaction",
                  filterPlaceholder: "schedule name",

                  filterItems: [
                    {
                      name: "Search",
                      isMulti: false,
                      value: searchdata,
                      setValue: SetsearchData,
                      isDropdown: false,
                      isDisabled: allBeneScheduleTxnLoading,
                    },
                    {
                      name: "Beneficiary account",
                      short_name: "Bene. Acc",
                      isMulti: false,
                      value: DestinationAccountName,
                      displayValue:
                        accountName?.toLowerCase() ||
                        accountNameValue?.toLowerCase(),
                      setValue: setDestinationAccountName,
                      setDisplayValue: (val) => {
                        setAccountName(val);
                        setAccountNameValue(val);
                      },
                      isDropdown: true,
                      valueType: "string",
                      isDisabled: allBeneScheduleTxnLoading,
                    },
                    {
                      name: "Owner account",
                      short_name: "Src. Acc",
                      isMulti: false,
                      value: txnPayLoadAccountNameFilter,
                      displayValue: standardAccountNumberFormat(
                        accountNumber,
                        true,
                      ),
                      setValue: setTxnPayLoadAccountNameFilter,
                      setDisplayValue: setAccountNumber,
                      valueType: "string",
                      isDropdown: true,
                      isDisabled: allBeneScheduleTxnLoading,
                    },
                    {
                      name: "Category",
                      valueType: "string",
                      short_name: "Cat",
                      isMulti: false,
                      value: initCategoryFilter,
                      displayValue: displayCategory,
                      setValue: (val) => {
                        const c =
                          allCategories.filter((x) => x.id === val)[0]?.name ??
                          "";
                        setDisplayCategory(c);
                        setPage(GlobalConfiguration.lengthCheckOne);
                        setInitCategoryFilter(val);
                        setActive("");
                      },
                      isDropdown: true,
                      isDisabled: allBeneScheduleTxnLoading,
                    },
                    {
                      name: "Labels",
                      short_name: "Lab",
                      isMulti: true,
                      value: LabelSearchText,
                      setValue: (val) => {
                        setPage(1);
                        setLabelSearchText(val);
                      },
                      isDropdown: true,
                    },
                    {
                      name: "Amount",
                      short_name: "Amt - INR",
                      isMulti: false,
                      value: txnAmountFilter,
                      setValue: setTxnAmountFilter,
                      displayValue: FormatAmount({
                        price: txnAmountFilter,
                      }),
                      isDropdown: false,
                      isDisabled: allBeneScheduleTxnLoading,
                      valueType: "number",
                    },
                  ],

                  filters: [
                    {
                      name: "Schedule start date",
                      filterType: "calender",
                      variant: "single",
                      size: "small",
                      value: startDateFilter,
                      isDisable: false,
                      startDate: startDateFilter,
                      minDate: new Date(),
                      maxDate: null,
                      handleChange: (date) => handleStartDateChange(date),
                    },
                    {
                      name: "Schedule end date",
                      filterType: "calender",
                      variant: "single",
                      size: "small",
                      value: endDateFilter,
                      isDisable: false,
                      startDate: endDateFilter,
                      minDate: new Date(),
                      maxDate: null,
                      handleChange: (date) => handleEndDateChange(date),
                    },
                    {
                      name: "Payment method",
                      filterType: "dropdown",
                      variant: "single",
                      isSearch: false,
                      options: ["NEFT", "RTGS"],
                      searchPlaceholder: "Search",
                      dropdownPlaceHolder: "Select type",
                      value: isPaymentMethod,
                      dropdownType: "PaymentMethod",
                      isDisable: false,
                      handleChange: (val) => handlePaymentMethod(val),
                    },
                    {
                      name: "Frequency",
                      filterType: "dropdown",
                      variant: "single",
                      isSearch: false,
                      options: [
                        "Once",
                        "Daily",
                        "Weekly",
                        "Fortnightly",
                        "Monthly",
                        "Quarterly",
                        "Half yearly",
                        "Yearly",
                      ],
                      searchPlaceholder: "Search",
                      dropdownPlaceHolder: "Select frequency",
                      value: FrequencyMethodfilter,
                      isDisable: false,
                      handleChange: (val) => handleFrequencyMethod(val),
                    },

                    {
                      name: "Show/hide confidential transactions",
                      filterType: "dropdown",
                      variant: "single",
                      isSearch: false,
                      options: ["Show only confidential", "Hide confidential"],
                      searchPlaceholder: "Search",
                      dropdownPlaceHolder: "Default (all transactions)",
                      value: confidentialMethodFilter,
                      handleChange: (val) => handleConfidentialMethod(val),
                    },
                  ],
                  isFilterClearAllDisabled: !(
                    isPaymentMethod?.length ||
                    FrequencyMethodfilter?.length ||
                    confidentialMethodFilter?.length ||
                    startDateFilter ||
                    endDateFilter ||
                    allBeneScheduleTxnLoading
                  ),
                  isSearchClearAllDisabled: !(
                    initCategoryFilter?.length ||
                    displayCategory?.length ||
                    searchdata?.length ||
                    FrequencyMethodfilter?.length ||
                    DestinationAccountName?.length ||
                    txnPayLoadAccountNameFilter?.length ||
                    beneAccountId?.length ||
                    isPaymentMethod?.length ||
                    txnAmountFilter?.length ||
                    txnPayLoadAccountNameFilter?.length ||
                    searchdata?.length ||
                    startDateFilter ||
                    endDateFilter ||
                    LabelSearchText?.length ||
                    allBeneScheduleTxnLoading
                  ),
                  inputData,
                  active,
                  setActive,
                  loading: loadingData,
                  setLoading: setLoadingData,
                  isShowFilter: true,
                }}
              />
            </div>

            <div
              className={`flex flex-col flex-1 overflow-y-auto  
              ${
                allAccounts?.length === GlobalConfiguration.lengthCheckZero ||
                allBeneScheduleTxnLoading
                  ? "pb-bottom-base"
                  : "Qsmd:pb-[var(--pagination-height)] pb-topnav-bottom-height"
              }`}
            >
              {showInnerSearchBar && (
                <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header"></div>
              )}
              {/* Main Content Area */}
              <div
                className={`w-width-full overflow-y-auto scroll-py-top_md h-[-webkit-fill-available] z-z-index-content`}
                style={{ overflow: showInnerSearchBar ? "hidden" : "auto" }}
              >
                {allBeneScheduleTxnLoading ? (
                  <div
                    style={{
                      opacity: showInnerSearchBar
                        ? "var(--opcacity_none)"
                        : "var(--base-opacity)",
                    }}
                    className="loader-container m-auto justify-center items-center flex h-height-full"
                  >
                    <Loader />
                  </div>
                ) : !allAccounts?.length ? (
                  <div className="int-txn-mutli-no-account-found">
                    <div className="flex justify-center items-center">
                      <img
                        src={
                          isFilterApplied
                            ? ICONS?.NO_DATA_FOUND
                            : ICONS?.NO_PENDING_TRANSACTION
                        }
                        className="w-graphic-width-md h-graphic-rectangle-height-md"
                        alt="NoData"
                      />
                    </div>
                    <div className="int-txn-mutli-left-text-content-no-account !mt-margin-sm">
                      {isFilterApplied ? (
                        <>
                          <p className="text-font-md text-text-primary text-center">
                            No data found.
                          </p>
                          <div className="mt-margin-sm">
                            <PrimaryButton
                              btnText="Clear Parameters"
                              handleFunction={handleClearParams}
                              enabledBgColor="var(--primary-nav-act)"
                              enabledTextColor="var(--text-primary)"
                              hoverOption="white"
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <p className="text-font-md text-text-primary text-center">
                            There are no more transactions that require <br />
                            your approval.
                          </p>
                          <div className="mt-margin-sm">
                            <PrimaryButton
                              btnText="Beneficiary transaction dashboard"
                              handleFunction={() =>
                                navigate("/beneficiary_transaction_dashboard")
                              }
                              enabledBgColor="var(--primary-act)"
                              enabledTextColor="var(--text-primary)"
                              hoverOption="white"
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                ) : (
                  <div
                    className={`${showInnerSearchBar ? "pointer-events-none" : "flex flex-col items-center justify-center mx-auto bg-primary-bg"}`}
                    style={{
                      scrollPaddingTop: "var(--padding-md)",
                      scrollPaddingBottom: "var(--padding-md)",
                    }}
                  >
                    <ScheduleBeneficiaryTransactionMultiApprovalCard
                      filterOpen={showInnerSearchBar}
                      setAllAccounts={setAllAccounts}
                      data={allAccounts}
                      selectedTransactions={selectedTransactions}
                      setSelectedTransactions={setSelectedTransactions}
                      totalAmount={totalAmount}
                      setselectAllCard={setselectAllCard}
                      setTotalAmount={setTotalAmount}
                      selectedSendTransactions={selectedSendTransactions}
                      setSelectedSendTransactions={setSelectedSendTransactions}
                      SideDrawerOpen={SideDrawerOpen}
                      openBeneTxnDetailModal={openBeneTxnDetailModal}
                      setTxnId={setTxnId}
                      setDatas={setDatas}
                    />
                  </div>
                )}
              </div>
            </div>

            {/* Footer Section (Pagination & Mob Next Button) */}
            <div
              className={`flex flex-col absolute bottom-bottom-base ${showInnerSearchBar ? "opacity-light-opacity bg-PopUp-BackDrop pointer-events-none" : "opacity-base-opacity"}`}
            >
              {(allAccounts?.length ?? GlobalConfiguration?.lengthCheckZero) !==
                GlobalConfiguration?.lengthCheckZero &&
                !allBeneScheduleTxnLoading && (
                  <div className="z-z-index-fixed-ui w-screen">
                    <PaginationComponent
                      handleSelect={handleSelect}
                      selectedValue={selectedValue}
                      data={mainData}
                      pageSize={pageSize}
                      dropdownOptions={dropdownOptions}
                      handlePagination={handlePagination}
                      currentPage={page}
                      setIsOpen={setIsOpen}
                    />
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ScheduleBeneficiaryMultiSelect;
